










import Vue from "vue";

export default Vue.extend({
  methods: {
    back: function() {
      this.$router.back();
    }
  }
});
